var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('write-vue',{attrs:{"organisation":_vm.organisation,"utmSource":_vm.utmSource,"utmMedium":_vm.utmMedium,"utmCampaign":_vm.utmCampaign,"utmTerm":_vm.utmTerm,"utmContent":_vm.utmContent,"metaTitle":_vm.metaTitle,"metaDescription":_vm.metaDescription,"image1":_vm.image1,"image2":_vm.image2}})
}
var staticRenderFns = []

export { render, staticRenderFns }